import EStyleSheet from "react-native-extended-stylesheet";

export const styles = EStyleSheet.create({
  button: {
    margin: 25,
    padding: 10,
    width: 250,
    borderWidth: 1,
    flexDirection: "row",
    alignItems: "center",
    justifyContent: "center",
    backgroundColor: "$media_button_bg",
    borderColor: "$option_card_outline",
  },
  disabled: {
    opacity: 0.5,
  },
  icon: {
    fontSize: "$media_button_icon_size",
  },
  text: {
    flex: 1,
    fontSize: "$h4",
    textAlign: "center",
    color: "$survey_card",
  },
});
